import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => {
  return {
    location: {
      flexGrow: 1,
    },
  };
});
